import moment from "moment";
import { BseDto, NegotiationRoundDto, NegotiationStateName } from "../../autogen/bff-api";
import { requirePublishedOrAwardedState } from "./requirePublishedOrAwardedState";

export const requireDeadlineHasPassed = (bse: BseDto, round?: NegotiationRoundDto): boolean => {
  if (round) {
    if (round.stateName === NegotiationStateName.Draft) return false;
    return moment().isAfter(moment(round.deadline));
  }

  const fields = requirePublishedOrAwardedState(bse);
  return moment().isAfter(moment(fields.deadline));
};
